import * as React from 'react';
import { Fade } from 'react-reveal';
import styled from 'styled-components';
import { Text, Heading4, TextInlineSkin } from '@origin-digital/style-guide';
import { SM, MD, LG, XL } from '@origin-digital/helper';
import { CardBlockProps, CardBlockPropsType } from './CardBlock.types';

const CardContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  flex-direction: row;

  + div {
    margin-top: 32px;
  }

  ${SM`
    flex-direction: column;

    & > * {
      width: 100%;
    }

    + div {
      margin-top: 0;
    }
  `}
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 104px;
  width: 104px;
  margin: 0 16px;

  ${SM`
    width: auto;
  `}

  ${LG`
    height: 133px;
  `}

  ${XL`
    height: 150px;
  `}
`;

const TextContainer = styled.div`
  padding: 0 16px;

  ${SM`
    padding-top: 24px;
  `}

  ${MD`
    padding-top: 32px;
  `}
`;

const SvgImage = styled(TextInlineSkin)`
  width: 100%;
  height: 100%;
`;

export const CardBlock: React.FunctionComponent<CardBlockProps> = ({
  title,
  content,
  iconSvg,
  delay
}) => {
  return (
    <CardContainer>
      <Fade
        effect="fadeInUp"
        duration={1000}
        delay={delay}
        ssrFadeout
        ssrReveal
        bottom
        distance="20%"
      >
        <ImageContainer>
          <SvgImage
            color="white"
            dangerouslySetInnerHTML={{
              __html: iconSvg
            }}
          />
        </ImageContainer>
        <TextContainer>
          <Heading4 text={title} marginBottom />
          <Text size="sm" overflow="normal">
            {content}
          </Text>
        </TextContainer>
      </Fade>
    </CardContainer>
  );
};

CardBlock.propTypes = CardBlockPropsType;

export default CardBlock;
